import styles from "../HealthChat.module.css";

const CONSENT_ITEMS = [
  {
    icon: "📄",
    text: "I have read and understand the study information provided.",
  },
  {
    icon: "🔒",
    text: "I understand that my data will be kept confidential and securef.",
  },
  {
    icon: "❤️",
    text: "I consent to the use of my health data for research purposes.",
  },
  {
    icon: "➕",
    text: "I understand that I can withdraw from the study at any time without penalty.",
  },
];

export default function ConsentScreen({
  t,
  agreed,
  onToggle,
  onExit,
  onAgree,
}) {
  return (
    <div className={styles.consentScreen}>
      {/* <div className={styles.consentShieldWrap}>
        <div className={styles.consentShield}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#fff" />
            <polyline
              points="9 12 11 14 15 10"
              stroke="var(--primary-color)"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </div>
      </div> */}
         <div className={styles.consentShieldPC} >


        <div className={styles.consentShield}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#fff" />
            <polyline
              points="9 12 11 14 15 10"
              stroke="var(--primary-color)"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </div>

      <div className={`ava-text-subheading `}>{t.title}</div>
      </div>
      <p className={`ava-text-body ${styles.consentIntro}`}>{t.intro}</p>

      {/* <div className={styles.consentDivider} /> */}

      <div className={styles.consentItemList}>
        {t.items.map((item, i) => (
          <div key={i} className={styles.consentItem}>
            <div className={styles.consentItemIcon}>
              <img
                src="/images/Group.svg"
                alt="icon"
                className={styles.consentItemIcon}
              />
            </div>
            <span className={`ava-text-body ${styles.consentItemText}`}>
              {item.text}
            </span>
          </div>
        ))}
      </div>

      {/* <div className={styles.consentDivider} /> */}

      <label className={styles.consentCheck}>
        <input type="checkbox" checked={agreed} onChange={onToggle} />
        <span className={`ava-text-body`}>{t.checkLabel}</span>
      </label>

      <div className={styles.consentActions}>
        <button className={`ava-text-body ${styles.exitBtn}`} onClick={onExit}>
          {t.exitBtn || "Decline"}
        </button>
        <button
          className={`ava-text-body ${styles.agreeBtn}`}
          disabled={!agreed}
          onClick={onAgree}
        >
          {t.agreeBtn || "Agree & Continue"} &rsaquo;
        </button>
      </div>

      <div className={`ava-text-caption ${styles.consentFooterNote} ${styles.CBbodyText}`}>
        If you have any questions, please contact the study team.
      </div>
    </div>
  );
}
